import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiEdit, FiTrash2, FiFileText, FiClock, FiCheckCircle, FiGlobe, FiCoins, FiExternalLink } = FiIcons;

const ArticleCard = ({ article, onEdit, onDelete, agencyName, domainName }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'published': return 'bg-success-100 text-success-800';
      case 'completed': return 'bg-primary-100 text-primary-800';
      case 'in_progress': return 'bg-warning-100 text-warning-800';
      case 'draft': return 'bg-gray-100 text-gray-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'published': return FiGlobe;
      case 'completed': return FiCheckCircle;
      case 'in_progress': return FiClock;
      default: return FiFileText;
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow"
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">{article.title}</h3>
          <div className="space-y-1 mb-3">
            <p className="text-sm text-gray-600">Client: {agencyName}</p>
            <p className="text-sm text-gray-600">Domain: {domainName}</p>
          </div>
          <div className="flex items-center space-x-2">
            <SafeIcon icon={getStatusIcon(article.status)} className="w-4 h-4" />
            <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(article.status)}`}>
              {article.status?.replace('_', ' ').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={() => onEdit(article)}
            className="p-2 text-gray-500 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
          >
            <SafeIcon icon={FiEdit} className="w-4 h-4" />
          </button>
          <button
            onClick={() => onDelete(article)}
            className="p-2 text-gray-500 hover:text-danger-600 hover:bg-danger-50 rounded-lg transition-colors"
          >
            <SafeIcon icon={FiTrash2} className="w-4 h-4" />
          </button>
        </div>
      </div>

      <div className="border-t pt-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-1">
            <SafeIcon icon={FiCoins} className="w-4 h-4 text-success-600" />
            <span className="text-lg font-bold text-success-600">
              {article.price?.toFixed(2) || '0.00'} LEI
            </span>
          </div>
          <span className="text-sm text-gray-500">ID: #{article.id.slice(-6)}</span>
        </div>
        
        <div className="flex items-center justify-between text-sm text-gray-500 mb-3">
          <span>Created: {new Date(article.created_at).toLocaleDateString()}</span>
          {article.published_at && (
            <span>Published: {new Date(article.published_at).toLocaleDateString()}</span>
          )}
        </div>
        
        {article.article_url && (
          <div className="mt-2">
            <a
              href={article.article_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-1 text-primary-600 hover:text-primary-800 text-sm font-medium"
            >
              <SafeIcon icon={FiExternalLink} className="w-3 h-3" />
              <span>View Live Article</span>
            </a>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default ArticleCard;